var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.827814 20.4999C0.910202 20.4999 0.992589 20.4999 1.04758 20.4725L6.78824 18.7996C7.09039 18.7173 7.39252 18.5528 7.61231 18.306L19.4507 6.48571C19.8078 6.12912 20 5.63557 20 5.11444C20 4.59331 19.8076 4.12713 19.4507 3.77055L16.7314 1.0554C15.9897 0.314867 14.7537 0.314867 14.0121 1.0554L2.20115 12.8757C1.98139 13.0951 1.81662 13.3968 1.70684 13.6985L0.0313372 19.4304C-0.0510499 19.7047 0.0313372 20.0338 0.2511 20.2532C0.415874 20.4177 0.635632 20.5 0.827814 20.5V20.4999ZM12.0619 5.3611L15.1658 8.46021L7.008 16.6055L3.90435 13.5066L12.0619 5.3611ZM15.2206 2.2071C15.2756 2.15219 15.3579 2.12483 15.4129 2.12483C15.4953 2.12483 15.5503 2.15219 15.6053 2.2071L18.3246 4.92225C18.3796 5.00451 18.407 5.08677 18.407 5.11432C18.407 5.14168 18.407 5.25149 18.3246 5.30639L16.3468 7.28082L13.2429 4.18171L15.2206 2.2071ZM3.05257 14.9599L5.52452 17.428L2.03613 18.4427L3.05257 14.9599Z",
    fill: "#3B1F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.964b8209fc65f3900c3a7919b352a922.svg";
export { ForwardRef as ReactComponent };